import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Button, { ButtonOwnProps } from '@mui/material/Button';
import { CircularProgress } from "@mui/material";

type BasicButtonDetails = {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean
};

interface ConfirmationModalProps {
    open: boolean;
    onClose: (value?: string) => void;
    fullWidth?: boolean;
    title: string;
    content: React.ReactElement | string;
    footer?: {
        primaryButton: BasicButtonDetails;
        secondaryButton?: BasicButtonDetails;
    };
    customFooter?: React.ReactElement;
}

const ConfirmationModal = (props: ConfirmationModalProps): React.ReactElement => {
    const { onClose, open, title, content, customFooter, footer, fullWidth = true } = props;

    const renderActionButton = (buttonDetails: BasicButtonDetails, otherProps?: ButtonOwnProps) => {
        const { label, onClick, disabled, loading } = buttonDetails;
        return (
            <Button onClick={onClick} disabled={disabled} size="small" {...otherProps} endIcon={loading && <CircularProgress size={20} />}>
                {label}
            </Button>
        );
    };
    const renderDialogActions = () => {
        if (footer) {
            const { primaryButton, secondaryButton } = footer;
            return (
                <>
                    {footer.secondaryButton && renderActionButton(secondaryButton, { color: 'inherit' })}
                    {renderActionButton(primaryButton)}
                </>
            );
        }

        return customFooter || null;
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth={fullWidth}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>{content}</DialogContent>
            <DialogActions>{renderDialogActions()}</DialogActions>
        </Dialog>
    );
};

export default ConfirmationModal;
